/* tslint:disable */
import React, { Fragment } from 'react'
import { FieldArray, useFormikContext } from 'formik'
import { IgoodsForm } from '../../../edit-goods'
import { InkWell } from '@/components/inkwell/inkwell'
import { getBEMCls } from '@/utils/classname'
import { Column, Expaned, Row } from '@/components/layout/layout'
import classNames from 'classnames'
import Input from '@/components/input/input'
import $msg from '@/utils/message'
import { showLayer } from '@/utils/layer'
import ChooseGoodsUnitDialog from '../../goods-unit/goods-unit'
import { goodsModel } from '../../model'
import './sale-price.scss'
import { Table } from 'antd'
import { observer } from 'mobx-react'
import { ColumnType } from 'antd/es/table'
import { get, INPUT_NUMBER_LIMIT_REGEXP, INPUT_PRICE_LIMIT_REGEXP, WithInputLimit } from '@/utils'
import Duihao from '@/assets/images/origin-correct.svg'
import { shopStore } from '@/store/shop'
import { shouldShowMallUnderlinePrice } from './sale-price-visibility'

interface SalePriceProps {
    unitName?: string
    showPriceType?: boolean // 是否展示商城价格配置
    mode?: 'create' | 'edit'
}

export const priceMethodType: Record<
    string,
    {
        style: string
        txt: string
    }
> = {
    0: {
        style: 'same',
        txt: '统一价',
    },
    1: {
        style: 'cashier',
        txt: '门店价',
    },
    2: {
        style: 'mall',
        txt: '商城价',
    },
}

// 条码秤序号自增，最大只能到9999，如：scaleCode = "0004"
const autoIncreScaleCode = (code: string = '0001', incre_num: number = 1) => {
    if (code === '' || !code) return ''
    let num = Number(code) + incre_num
    if (num > 9999) return ''
    return String(num).padStart(4, '0')
}

const SalePrice: React.FC<SalePriceProps> = observer(props => {
    const { values, handleBlur, handleChange, setFieldValue, errors, touched } = useFormikContext<IgoodsForm>()
    const cls = (...args: string[]) => getBEMCls('edit-goods', ...args)

    const stockUnitName = goodsModel.goodsUnit.find(val => val.id === values.stock_unit_id)?.name || props.unitName

    const checkError = (key: string) => {
        return !!(get(errors, key) && get(touched, key))
    }

    const getErrorStr = (key: string) => {
        return get(errors, key) && get(touched, key) && get(errors, key)
    }

    return (
        <FieldArray name="pricing_methods">
            {arrayHelpers => {
                return (
                    <Fragment>
                        {values.pricing_methods.map((val, pricingMethodIndex, arr) => {
                            const saleUnitName =
                                goodsModel.goodsUnit.find(unit => unit.id === val.sales_unit_id)?.name ||
                                val.sales_unit?.name

                            return (
                                <Fragment key={pricingMethodIndex}>
                                    <Row data-margin-top-16 data-margin-left-90>
                                        {[0, 1, 2].map(n => (
                                            <div
                                                key={n}
                                                className={classNames({
                                                    [`${cls(
                                                        'price-type',
                                                        priceMethodType[val.method_type || 0].style,
                                                    )}`]: n === val.method_type,
                                                    [`${cls('price-type', 'unselect')}`]: n !== val.method_type,
                                                    [`${cls('price-type')}`]: true,
                                                })}
                                                onClick={() => {
                                                    setFieldValue(
                                                        `pricing_methods[${pricingMethodIndex}].method_type`,
                                                        n,
                                                    )
                                                }}
                                            >
                                                {priceMethodType[n as 0 | 2 | 1].txt}
                                                {n === val.method_type && (
                                                    <img className={cls('price-type', 'icon')} src={Duihao} alt="" />
                                                )}
                                            </div>
                                        ))}
                                    </Row>
                                    <Row
                                        data-align-items-center
                                        data-padding-h-24
                                        data-margin-top-16
                                        data-position-relative
                                    >
                                        {arr.length > 1 ? (
                                            <span className={classNames(cls('form-item', 'title'), cls('sale-price'))}>
                                                售价
                                                {['一', '二', '三', '四', '五', '六', '七', '八'][pricingMethodIndex]}
                                            </span>
                                        ) : (
                                            <span
                                                data-color-000
                                                className={classNames(cls('form-item', 'title'), cls('sale-price'))}
                                            >
                                                售价
                                            </span>
                                        )}
                                        <Row
                                            data-align-items-center
                                            data-expaned
                                            data-position-relative
                                            style={{
                                                marginLeft: '70px',
                                            }}
                                        >
                                            <Input
                                                inputprefix={() => {
                                                    return (
                                                        <span
                                                            className={classNames(
                                                                cls('form-item', 'title'),
                                                                cls('form-item', 'require'),
                                                            )}
                                                        >
                                                            计价单位
                                                        </span>
                                                    )
                                                }}
                                                inputsuffix={() => {
                                                    return (
                                                        <Row
                                                            data-expaned
                                                            data-algin-items-center
                                                            onClick={() => {
                                                                if (!values.allow_multiple_units) {
                                                                    $msg(
                                                                        'warning',
                                                                        '单一单位下不允许修改计价单位，请修改单位模式或库存单位',
                                                                    )
                                                                } else {
                                                                    showLayer(
                                                                        <ChooseGoodsUnitDialog
                                                                            goodsModel={goodsModel}
                                                                            choosedId={val.sales_unit?.id}
                                                                            onChange={unit => {
                                                                                arrayHelpers.form.setFieldValue(
                                                                                    `pricing_methods[${pricingMethodIndex}].sales_unit_id`,
                                                                                    unit.id,
                                                                                )
                                                                                arrayHelpers.form.setFieldValue(
                                                                                    `pricing_methods[${pricingMethodIndex}].sales_unit.id`,
                                                                                    unit.id,
                                                                                )
                                                                            }}
                                                                        ></ChooseGoodsUnitDialog>,
                                                                    )
                                                                }
                                                            }}
                                                        >
                                                            <Expaned data-row data-algin-items-center>
                                                                <span data-font-size-14 data-color-000>
                                                                    元/{saleUnitName}
                                                                </span>
                                                            </Expaned>
                                                            <i className="iconfont icon6xiala2-202"></i>
                                                        </Row>
                                                    )
                                                }}
                                                // 设置内部input display none
                                                style={{ display: 'none' }}
                                            ></Input>
                                        </Row>
                                    </Row>

                                    {/* 换算规则 */}
                                    <Row data-align-items-center data-padding-h-24>
                                        <span
                                            data-color-999
                                            data-font-weight-400
                                            className={classNames(cls('form-item', 'title'))}
                                        ></span>
                                        <Column data-expaned>
                                            <Row data-align-items-center data-expaned data-position-relative>
                                                <Input
                                                    error={checkError(
                                                        `pricing_methods[${pricingMethodIndex}].sales_unit_ratio`,
                                                    )}
                                                    reg={INPUT_NUMBER_LIMIT_REGEXP}
                                                    name={`pricing_methods[${pricingMethodIndex}].sales_unit_ratio`}
                                                    value={values.pricing_methods[pricingMethodIndex].sales_unit_ratio}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    style={{
                                                        paddingLeft: '4px',
                                                    }}
                                                    disabled={
                                                        values.stock_unit_id ===
                                                        values.pricing_methods[pricingMethodIndex].sales_unit_id
                                                    }
                                                    inputprefix={() => {
                                                        return (
                                                            <Row data-align-items-center>
                                                                <span
                                                                    className={classNames(
                                                                        cls('form-item', 'title'),
                                                                        cls('form-item', 'require'),
                                                                    )}
                                                                >
                                                                    换算规则
                                                                </span>
                                                                <div data-font-size-14 data-color-333>
                                                                    1{saleUnitName}=
                                                                </div>
                                                            </Row>
                                                        )
                                                    }}
                                                    inputsuffix={() => {
                                                        return (
                                                            <span data-font-size-14 data-color-999>
                                                                {stockUnitName}(库存单位)
                                                            </span>
                                                        )
                                                    }}
                                                ></Input>
                                            </Row>
                                            <span data-padding-top-8 className={classNames(cls('form-item', 'error'))}>
                                                {getErrorStr(`pricing_methods[${pricingMethodIndex}].sales_unit_ratio`)}
                                            </span>
                                        </Column>
                                    </Row>

                                    <FieldArray name={`pricing_methods[${pricingMethodIndex}].sale_prices`}>
                                        {salePricesArrayHelpers => {
                                            const columns: ColumnType<any>[] = [
                                                {
                                                    title: '档位',
                                                    dataIndex: '',
                                                    align: 'center',
                                                    render: (text, record, index) => {
                                                        return (
                                                            <span data-center data-font-weight-600 data-color-000>
                                                                {['一', '二', '三'][index]}级
                                                            </span>
                                                        )
                                                    },
                                                },
                                                {
                                                    title: '购买量',
                                                    align: 'center',
                                                    render: (text, record, index) => {
                                                        return (
                                                            <Fragment>
                                                                {index === 0 ? (
                                                                    <span>{'>='}0</span>
                                                                ) : (
                                                                    <Column>
                                                                        <Row data-justify-content-center>
                                                                            <span>{'>='}</span>
                                                                            {WithInputLimit(
                                                                                <input
                                                                                    // tslint:disable-next-line:max-line-length
                                                                                    name={`pricing_methods[${pricingMethodIndex}].sale_prices[${index}].threshold`}
                                                                                    // tslint:disable-next-line:max-line-length
                                                                                    value={
                                                                                        values.pricing_methods[
                                                                                            pricingMethodIndex
                                                                                        ].sale_prices[index].threshold
                                                                                    }
                                                                                    autoComplete="off"
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    placeholder="请输入"
                                                                                    className={cls('table', 'input')}
                                                                                    data-width-50
                                                                                    type="text"
                                                                                />,
                                                                                INPUT_NUMBER_LIMIT_REGEXP,
                                                                            )}
                                                                            <span>{saleUnitName}</span>
                                                                        </Row>
                                                                        <span
                                                                            data-padding-top-8
                                                                            className={classNames(
                                                                                cls('form-item', 'error'),
                                                                            )}
                                                                        >
                                                                            {getErrorStr(
                                                                                `pricing_methods[${pricingMethodIndex}].sale_prices[${index}].threshold`,
                                                                            )}
                                                                        </span>
                                                                    </Column>
                                                                )}
                                                            </Fragment>
                                                        )
                                                    },
                                                },
                                                {
                                                    title: '单价',
                                                    dataIndex: '',
                                                    render: (text, record, index) => {
                                                        return (
                                                            <Fragment>
                                                                {
                                                                    <Column>
                                                                        <Row data-justify-content-center>
                                                                            {WithInputLimit(
                                                                                <input
                                                                                    // tslint:disable-next-line:max-line-length
                                                                                    name={`pricing_methods[${pricingMethodIndex}].sale_prices[${index}].sale_price`}
                                                                                    // tslint:disable-next-line:max-line-length
                                                                                    value={
                                                                                        values.pricing_methods[
                                                                                            pricingMethodIndex
                                                                                        ].sale_prices[index].sale_price
                                                                                    }
                                                                                    onChange={handleChange}
                                                                                    onBlur={handleBlur}
                                                                                    autoComplete="off"
                                                                                    placeholder="请输入"
                                                                                    className={cls('table', 'input')}
                                                                                    data-width-50
                                                                                    type="text"
                                                                                />,
                                                                                INPUT_PRICE_LIMIT_REGEXP,
                                                                            )}
                                                                            <span>元/{saleUnitName}</span>
                                                                        </Row>
                                                                        <span
                                                                            data-padding-top-8
                                                                            className={classNames(
                                                                                cls('form-item', 'error'),
                                                                            )}
                                                                        >
                                                                            {getErrorStr(
                                                                                `pricing_methods[${pricingMethodIndex}].sale_prices[${index}].sale_price`,
                                                                            )}
                                                                        </span>
                                                                    </Column>
                                                                }
                                                            </Fragment>
                                                        )
                                                    },
                                                },
                                                {
                                                    title: '',
                                                    dataIndex: '',
                                                    render: (text, record, index) => {
                                                        return index === 0 ? null : (
                                                            <Row
                                                                data-justify-content-center
                                                                onClick={() => {
                                                                    salePricesArrayHelpers.remove(index)
                                                                }}
                                                            >
                                                                <i
                                                                    style={{ color: '#f00' }}
                                                                    className="iconfont icon6yichu-20"
                                                                ></i>
                                                            </Row>
                                                        )
                                                    },
                                                },
                                            ]

                                            return (
                                                <Fragment>
                                                    {values.pricing_methods[pricingMethodIndex].sale_prices.length ===
                                                    1 ? (
                                                        <Fragment>
                                                            <Row data-align-items-center data-padding-h-24>
                                                                <span
                                                                    data-color-999
                                                                    data-font-weight-400
                                                                    className={classNames(cls('form-item', 'title'))}
                                                                ></span>
                                                                <Column data-expaned>
                                                                    <Row
                                                                        data-align-items-center
                                                                        data-expaned
                                                                        data-position-relative
                                                                    >
                                                                        <Input
                                                                            error={checkError(
                                                                                `pricing_methods[${pricingMethodIndex}].sale_prices[0].sale_price`,
                                                                            )}
                                                                            reg={INPUT_PRICE_LIMIT_REGEXP}
                                                                            name={`pricing_methods[${pricingMethodIndex}].sale_prices[0].sale_price`}
                                                                            value={
                                                                                values.pricing_methods[
                                                                                    pricingMethodIndex
                                                                                ].sale_prices[0].sale_price
                                                                            }
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            inputprefix={() => {
                                                                                return (
                                                                                    <span
                                                                                        className={classNames(
                                                                                            cls('form-item', 'title'),
                                                                                            cls('form-item', 'require'),
                                                                                        )}
                                                                                    >
                                                                                        参考售价
                                                                                    </span>
                                                                                )
                                                                            }}
                                                                            placeholder="请输入"
                                                                            inputsuffix={() => {
                                                                                return (
                                                                                    <Row data-algin-items-center>
                                                                                        <span
                                                                                            data-font-size-14
                                                                                            data-color-000
                                                                                        >
                                                                                            元/{saleUnitName}
                                                                                        </span>
                                                                                    </Row>
                                                                                )
                                                                            }}
                                                                        ></Input>
                                                                    </Row>
                                                                    <span
                                                                        data-padding-top-8
                                                                        className={classNames(
                                                                            cls('form-item', 'error'),
                                                                        )}
                                                                    >
                                                                        {getErrorStr(
                                                                            `pricing_methods[${pricingMethodIndex}].sale_prices[0].sale_price`,
                                                                        )}
                                                                    </span>
                                                                </Column>
                                                            </Row>

                                                            <Row
                                                                data-align-items-center
                                                                data-height-50
                                                                data-padding-h-24
                                                            >
                                                                <span
                                                                    data-color-999
                                                                    data-font-weight-400
                                                                    className={classNames(cls('form-item', 'title'))}
                                                                ></span>
                                                                <Row
                                                                    onClick={() => {
                                                                        salePricesArrayHelpers.push({
                                                                            sale_price: '',
                                                                            threshold: '',
                                                                            sale_unit: {
                                                                                id: 2,
                                                                                name: '斤',
                                                                                status: 0,
                                                                            },
                                                                        })
                                                                    }}
                                                                    data-align-items-center
                                                                    data-expaned
                                                                    data-position-relative
                                                                >
                                                                    <span className="text-btn-blue">+新增阶梯价</span>
                                                                </Row>
                                                            </Row>
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                            <Row data-padding-h-24 data-margin-top-16>
                                                                <span
                                                                    className={classNames(
                                                                        cls('form-item', 'title'),
                                                                        cls('form-item', 'require'),
                                                                    )}
                                                                ></span>
                                                                <Row data-position-relative data-expaned>
                                                                    <span
                                                                        className={classNames(
                                                                            cls('form-item', 'title'),
                                                                            cls('form-item', 'require'),
                                                                        )}
                                                                    >
                                                                        参考售价
                                                                    </span>
                                                                    <Expaned>
                                                                        <Table
                                                                            bordered
                                                                            pagination={false}
                                                                            rowKey={record => record.price}
                                                                            columns={columns}
                                                                            dataSource={
                                                                                values.pricing_methods[
                                                                                    pricingMethodIndex
                                                                                ].sale_prices
                                                                            }
                                                                            footer={() => {
                                                                                // tslint:disable-next-line:max-line-length
                                                                                return values.pricing_methods[
                                                                                    pricingMethodIndex
                                                                                ].sale_prices.length < 3 ? (
                                                                                    <Row
                                                                                        data-align-items-center
                                                                                        data-justify-content-center
                                                                                        data-expaned
                                                                                        onClick={() => {
                                                                                            salePricesArrayHelpers.push(
                                                                                                {
                                                                                                    sale_price: '',
                                                                                                    threshold: '',
                                                                                                    sale_unit: {
                                                                                                        id: 2,
                                                                                                        name: '斤',
                                                                                                        status: 0,
                                                                                                    },
                                                                                                },
                                                                                            )
                                                                                        }}
                                                                                    >
                                                                                        <span className="text-btn-blue">
                                                                                            +新增阶梯价
                                                                                        </span>
                                                                                    </Row>
                                                                                ) : (
                                                                                    false
                                                                                )
                                                                            }}
                                                                        ></Table>
                                                                    </Expaned>
                                                                </Row>
                                                            </Row>
                                                        </Fragment>
                                                    )}
                                                </Fragment>
                                            )
                                        }}
                                    </FieldArray>

                                    {shouldShowMallUnderlinePrice(props.showPriceType, val.method_type) && (
                                        <Row data-align-items-center data-padding-h-24 data-margin-top-8>
                                            <span
                                                data-color-999
                                                data-font-weight-400
                                                className={classNames(cls('form-item', 'title'))}
                                            ></span>
                                            <Row data-align-items-center data-expaned data-position-relative>
                                                <Input
                                                    reg={INPUT_PRICE_LIMIT_REGEXP}
                                                    name={`pricing_methods[${pricingMethodIndex}].mall_display.underline_price`}
                                                    value={
                                                        values.pricing_methods[pricingMethodIndex].mall_display
                                                            ?.underline_price ?? ''
                                                    }
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    inputprefix={() => {
                                                        return (
                                                            <span className={classNames(cls('form-item', 'title'))}>
                                                                划线原价
                                                            </span>
                                                        )
                                                    }}
                                                    placeholder="请输入"
                                                    inputsuffix={() => {
                                                        return (
                                                            <Row data-algin-items-center>
                                                                <span data-font-size-14 data-color-000>
                                                                    元/{saleUnitName}
                                                                </span>
                                                            </Row>
                                                        )
                                                    }}
                                                ></Input>
                                            </Row>
                                        </Row>
                                    )}

                                    <Row data-align-items-center data-padding-h-24 data-margin-top-8>
                                        <span
                                            data-color-999
                                            data-font-weight-400
                                            className={classNames(cls('form-item', 'title'))}
                                        ></span>
                                        <Column data-expaned>
                                            <Row data-align-items-center data-expaned data-position-relative>
                                                <Input
                                                    reg={INPUT_PRICE_LIMIT_REGEXP}
                                                    error={checkError(
                                                        `pricing_methods[${pricingMethodIndex}].member_price`,
                                                    )}
                                                    name={`pricing_methods[${pricingMethodIndex}].member_price.sale_price`}
                                                    value={
                                                        values.pricing_methods[pricingMethodIndex].member_price
                                                            .sale_price || ''
                                                    }
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    inputprefix={() => {
                                                        return (
                                                            <span className={classNames(cls('form-item', 'title'))}>
                                                                会员价
                                                            </span>
                                                        )
                                                    }}
                                                    placeholder="请输入"
                                                    inputsuffix={() => {
                                                        return (
                                                            <Row data-algin-items-center>
                                                                <span data-font-size-14 data-color-000>
                                                                    元/{saleUnitName}
                                                                </span>
                                                            </Row>
                                                        )
                                                    }}
                                                ></Input>
                                            </Row>
                                            <span data-padding-top-8 className={classNames(cls('form-item', 'error'))}>
                                                {getErrorStr(`pricing_methods[${pricingMethodIndex}].member_price`)}
                                            </span>
                                        </Column>
                                    </Row>

                                    {!values.pricing_methods[pricingMethodIndex].isShowMemberPriceLimit &&
                                    values.pricing_methods[pricingMethodIndex].member_price.amount_limit.length ===
                                        0 ? (
                                        <Row
                                            onClick={() => {
                                                setFieldValue(
                                                    `pricing_methods[${pricingMethodIndex}].isShowMemberPriceLimit`,
                                                    true,
                                                )
                                            }}
                                            data-align-items-center
                                            data-height-50
                                            data-padding-h-24
                                        >
                                            <span
                                                data-color-999
                                                data-font-weight-400
                                                className={classNames(cls('form-item', 'title'))}
                                            ></span>
                                            <Row data-align-items-center data-expaned data-position-relative>
                                                <span className="text-btn-blue">+会员价限购</span>
                                            </Row>
                                        </Row>
                                    ) : (
                                        <Row data-align-items-center data-padding-h-24 data-margin-top-8>
                                            <span
                                                data-color-999
                                                data-font-weight-400
                                                className={classNames(cls('form-item', 'title'))}
                                            ></span>
                                            <Row data-align-items-center data-expaned data-position-relative>
                                                <Input
                                                    reg={INPUT_NUMBER_LIMIT_REGEXP}
                                                    name={`pricing_methods[${pricingMethodIndex}].member_price.amount_limit`}
                                                    value={
                                                        values.pricing_methods[pricingMethodIndex].member_price
                                                            .amount_limit || ''
                                                    }
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    inputprefix={() => {
                                                        return (
                                                            <span className={classNames(cls('form-item', 'title'))}>
                                                                限购
                                                            </span>
                                                        )
                                                    }}
                                                    placeholder="请输入"
                                                    inputsuffix={() => {
                                                        return (
                                                            <Row data-algin-items-center>
                                                                <span data-font-size-14 data-color-000>
                                                                    {saleUnitName}
                                                                </span>
                                                            </Row>
                                                        )
                                                    }}
                                                ></Input>
                                            </Row>
                                        </Row>
                                    )}

                                    <Row data-align-items-center data-padding-h-24 data-margin-top-8>
                                        <span
                                            data-color-999
                                            data-font-weight-400
                                            className={classNames(cls('form-item', 'title'))}
                                        ></span>
                                        <Row data-align-items-center data-expaned data-position-relative>
                                            <Input
                                                type="text"
                                                maxLength={10}
                                                name={`pricing_methods[${pricingMethodIndex}].price_annotation`}
                                                value={values.pricing_methods[pricingMethodIndex].price_annotation}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                inputprefix={() => {
                                                    return (
                                                        <span className={classNames(cls('form-item', 'title'))}>
                                                            计价说明
                                                        </span>
                                                    )
                                                }}
                                                placeholder="填写后会展示在商城商品详情页; 如: 一份约十斤"
                                                inputsuffix={() => {
                                                    return (
                                                        <Row data-algin-items-center>
                                                            <span data-font-size-14 data-color-000>
                                                                {
                                                                    values.pricing_methods[pricingMethodIndex]
                                                                        .price_annotation.length
                                                                }
                                                                /10
                                                            </span>
                                                        </Row>
                                                    )
                                                }}
                                            ></Input>
                                        </Row>
                                    </Row>

                                    <Row data-align-items-center data-padding-h-24>
                                        <span
                                            data-color-999
                                            data-font-weight-400
                                            className={classNames(cls('form-item', 'title'))}
                                        ></span>
                                        <Row data-align-items-center data-expaned data-position-relative>
                                            <Input
                                                reg={/^\d{0,18}$/}
                                                name={`pricing_methods[${pricingMethodIndex}].price_code`}
                                                value={values.pricing_methods[pricingMethodIndex].price_code}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                inputprefix={() => {
                                                    return (
                                                        <span className={classNames(cls('form-item', 'title'))}>
                                                            子编码
                                                        </span>
                                                    )
                                                }}
                                                placeholder="请输入"
                                                inputsuffix={() => {
                                                    return (
                                                        <Row data-algin-items-center>
                                                            <span data-font-size-14 data-color-000>
                                                                {
                                                                    values.pricing_methods[pricingMethodIndex]
                                                                        .price_code?.length
                                                                }
                                                                /18
                                                            </span>
                                                        </Row>
                                                    )
                                                }}
                                            ></Input>
                                        </Row>
                                    </Row>

                                    {shopStore.shopInfo?.is_scale_mode && (
                                        <Row data-align-items-center data-padding-h-24>
                                            <span
                                                data-color-999
                                                data-font-weight-400
                                                className={classNames(cls('form-item', 'title'))}
                                            ></span>
                                            <Column className="expaned">
                                                <Row data-align-items-center data-expaned data-position-relative>
                                                    <Input
                                                        reg={/^\d{0,4}$/}
                                                        name={`pricing_methods[${pricingMethodIndex}].scale_num`}
                                                        value={values.pricing_methods[pricingMethodIndex].scale_num}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        inputprefix={() => {
                                                            return (
                                                                <span className={classNames(cls('form-item', 'title'))}>
                                                                    条码秤序号
                                                                </span>
                                                            )
                                                        }}
                                                        placeholder="请输入4位编码"
                                                        inputsuffix={() => {
                                                            return (
                                                                <Row data-algin-items-center>
                                                                    <span data-font-size-14 data-color-000>
                                                                        {
                                                                            values.pricing_methods[pricingMethodIndex]
                                                                                .scale_num?.length
                                                                        }
                                                                        /4
                                                                    </span>
                                                                </Row>
                                                            )
                                                        }}
                                                    ></Input>
                                                </Row>
                                                <span
                                                    data-padding-top-8
                                                    className={classNames(cls('form-item', 'error'))}
                                                >
                                                    {getErrorStr(`pricing_methods[${pricingMethodIndex}].scale_num`)}
                                                </span>
                                            </Column>
                                        </Row>
                                    )}

                                    <FieldArray name={`pricing_methods[${pricingMethodIndex}].barcodes`}>
                                        {barcodesArrayHelper => {
                                            return (
                                                <Fragment>
                                                    {values.pricing_methods[pricingMethodIndex].barcodes.map(
                                                        (val, index, arr) => {
                                                            return (
                                                                <Row
                                                                    key={index}
                                                                    data-align-items-center
                                                                    data-padding-h-24
                                                                >
                                                                    <span
                                                                        data-color-999
                                                                        data-font-weight-400
                                                                        className={classNames(
                                                                            cls('form-item', 'title'),
                                                                        )}
                                                                    ></span>
                                                                    <Column data-expaned>
                                                                        <Row
                                                                            data-align-items-center
                                                                            data-expaned
                                                                            data-position-relative
                                                                        >
                                                                            <Input
                                                                                reg={/^\d{0,14}$/}
                                                                                error={checkError(
                                                                                    `pricing_methods[${pricingMethodIndex}].barcodes[${index}]`,
                                                                                )}
                                                                                name={`pricing_methods[${pricingMethodIndex}].barcodes[${index}]`}
                                                                                value={
                                                                                    values.pricing_methods[
                                                                                        pricingMethodIndex
                                                                                    ].barcodes[index]
                                                                                }
                                                                                onChange={handleChange}
                                                                                onBlur={handleBlur}
                                                                                inputprefix={() => {
                                                                                    return (
                                                                                        <span
                                                                                            className={classNames(
                                                                                                cls(
                                                                                                    'form-item',
                                                                                                    'title',
                                                                                                ),
                                                                                            )}
                                                                                        >
                                                                                            子条码
                                                                                            {arr.length > 1 &&
                                                                                                index + 1}
                                                                                        </span>
                                                                                    )
                                                                                }}
                                                                                placeholder="请输入"
                                                                                inputsuffix={() => {
                                                                                    return (
                                                                                        <Row data-algin-items-center>
                                                                                            <span
                                                                                                data-font-size-14
                                                                                                data-color-000
                                                                                            >
                                                                                                {
                                                                                                    values
                                                                                                        .pricing_methods[
                                                                                                        pricingMethodIndex
                                                                                                    ].barcodes[index]
                                                                                                        .length
                                                                                                }
                                                                                                /14
                                                                                            </span>
                                                                                            {index !== 0 && (
                                                                                                <i
                                                                                                    onClick={() => {
                                                                                                        barcodesArrayHelper.remove(
                                                                                                            index,
                                                                                                        )
                                                                                                    }}
                                                                                                    style={{
                                                                                                        color: '#f00',
                                                                                                    }}
                                                                                                    data-margin-left-4
                                                                                                    className="iconfont icon6yichu-20"
                                                                                                ></i>
                                                                                            )}
                                                                                        </Row>
                                                                                    )
                                                                                }}
                                                                            ></Input>
                                                                        </Row>
                                                                        <span
                                                                            data-padding-top-8
                                                                            className={classNames(
                                                                                cls('form-item', 'error'),
                                                                            )}
                                                                        >
                                                                            {getErrorStr(
                                                                                `pricing_methods[${pricingMethodIndex}].barcodes[${index}]`,
                                                                            )}
                                                                        </span>
                                                                    </Column>
                                                                </Row>
                                                            )
                                                        },
                                                    )}

                                                    <Row data-align-items-center data-height-50 data-padding-h-24>
                                                        <span
                                                            data-color-999
                                                            data-font-weight-400
                                                            className={classNames(cls('form-item', 'title'))}
                                                        ></span>
                                                        <Row
                                                            onClick={() => {
                                                                barcodesArrayHelper.push('')
                                                            }}
                                                            data-align-items-center
                                                            data-expaned
                                                            data-position-relative
                                                        >
                                                            <span className="text-btn-blue">+新增子条码</span>
                                                        </Row>
                                                    </Row>
                                                </Fragment>
                                            )
                                        }}
                                    </FieldArray>
                                </Fragment>
                            )
                        })}
                        <InkWell
                            onClick={() => {
                                // 计算当前的条码秤序号
                                let cur_scale_num = ''
                                if (shopStore.shopInfo?.is_auto_scale_num) {
                                    if (props.mode === 'create') {
                                        // 直接取最后一个单位上的序号+1
                                        cur_scale_num = autoIncreScaleCode(
                                            values.pricing_methods[values.pricing_methods.length - 1].scale_num,
                                            1,
                                        )
                                    } else {
                                        const last_unit_scale_num =
                                            values.pricing_methods[values.pricing_methods.length - 1].scale_num
                                        if (last_unit_scale_num && last_unit_scale_num >= goodsModel.autoScaleNum) {
                                            cur_scale_num = autoIncreScaleCode(
                                                values.pricing_methods[values.pricing_methods.length - 1].scale_num,
                                                1,
                                            )
                                        } else {
                                            cur_scale_num = goodsModel.autoScaleNum
                                        }
                                    }
                                }
                                arrayHelpers.push({
                                    pricing_method_id: null, // 计价方式id
                                    sales_unit_id: 2, // 计价单位ID
                                    sales_unit_ratio: '1', //  计价单位换算率
                                    sale_prices: [
                                        {
                                            sale_price: '',
                                            threshold: 0,
                                            sale_unit: {
                                                id: 2,
                                                name: '斤',
                                                status: 0,
                                            },
                                        },
                                    ],
                                    method_type: 0,
                                    member_price: {
                                        sale_price: '',
                                        amount_limit: '',
                                        sale_unit: {
                                            id: 2,
                                            name: '斤',
                                            status: 0,
                                        },
                                    },
                                    ...(props.showPriceType
                                        ? {
                                              mall_display: {
                                                  underline_price: '',
                                              },
                                          }
                                        : {}),
                                    price_annotation: '', // 计价说明
                                    price_code:
                                        goodsModel.generateCode?.new_price_code[0][values.pricing_methods.length], // 商品编码
                                    scale_num: cur_scale_num, // 条码秤序号
                                    barcodes: [''],
                                    sales_unit: {
                                        id: 2,
                                        name: '斤',
                                        status: 0,
                                    },
                                })
                            }}
                            className={cls('form-item', 'add-new-sale-price-btn')}
                        >
                            +新增售价
                        </InkWell>
                    </Fragment>
                )
            }}
        </FieldArray>
    )
})

export default SalePrice
